import React, { useEffect, useReducer, useRef, useState } from "react";
import NavigateBack from "../../components/navigateBack";
import { t } from "i18next";
import { makeStyles } from "@material-ui/core";
import MessageView from "./message";
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import Channel from "@sendbird/uikit-react/Channel";
import { ChannelProvider } from "@sendbird/uikit-react/Channel/context";
import MessageListParent from "./messageListParent";
import MessageInput from "./messageInput";
import createPersistedState from "use-persisted-state";

import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import { useLocation } from "react-router-dom";

const initialState = {
  IS_LOADING: false,
  IS_ERROR: false,
  IS_LOADED: false,
  data: undefined,
};

const useStyles = makeStyles((theme) => ({
  messageListParent: { height: "calc(100vh - 262px)", overflow: "auto" },
  messageInputParent: { height: "165px" },
  messageInput: {
    width: "100%",
    height: "100%",
    resize: "none",
    border: "1px solid #00000033",
    borderRadius: "4px",
  },
  messageInputContainer: {
    width: "100%",
    height: "120px",
  },
  sendMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "calc(100% - 72px)",
  },
  userProfileIconParent: {
    backgroundColor: "blue",
    height: "20px",
    width: "20px",
    marginTop: "10px",
    marginRight: "10px",
  },
  messageInputBottom: {
    position: "fixed",
    bottom: "0px",
    width: "100%",
    display: "flex",
  },
}));

const useTokenState = createPersistedState("token");
const useProfileState = createPersistedState("profile");

const chatStateReducer = (state, action) => {
  switch (action.type) {
    case "LOADED":
      return {
        IS_LOADING: false,
        IS_ERROR: false,
        IS_LOADED: true,
        data: {
          chatProviderMetadata: action.payload.appData,
          chatData: action.payload.data,
        },
      };
    case "LOADING":
      return {
        IS_LOADING: true,
        IS_ERROR: false,
        IS_LOADED: false,
        data: undefined,
      };
    case "ERROR":
      return {
        IS_LOADING: false,
        IS_ERROR: true,
        IS_LOADED: false,
        data: undefined,
      };
    default:
      return state;
  }
};

const chatStatusReducer = (state, action) => {
  switch (action.type) {
    case "LOADED":
      return {
        IS_LOADING: false,
        IS_ERROR: false,
        IS_LOADED: true,
        data: action.payload.init,
      };
    case "LOADING":
      return {
        IS_LOADING: true,
        IS_ERROR: false,
        IS_LOADED: false,
        data: undefined,
      };
    case "ERROR":
      return {
        IS_LOADING: false,
        IS_ERROR: true,
        IS_LOADED: false,
        data: undefined,
      };
    default:
      return state;
  }
};

const ChatPage = () => {
  const classes = useStyles();

  const [token, _] = useTokenState();
  const [profile, setProfile] = useProfileState();
  const location = useLocation();

  const [state, dispatch] = useReducer(chatStateReducer, initialState);

  const [isChatActivatedState, dispatchIsChatActivated] = useReducer(
    chatStatusReducer,
    initialState
  );

  const [isAdmin, setIsAdmin] = useState(false);
  const [channel, setChannel] = useState(null);

  const checkChatStatus = async () => {
    dispatchIsChatActivated({ type: "LOADING" });
    const URL = `/api/v1/chat/channel/status`;
    try {
      const response = await fetch(URL, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      const data = await response.json();
      if (data?.status?.success) {
        dispatchIsChatActivated({ type: "LOADED", payload: data });
        return data;
      } else {
        dispatchIsChatActivated({ type: "ERROR" });
        return null;
      }
    } catch (e) {
      return null;
    }
  };

  const initChat = async (isAdmin) => {
    dispatch({ type: "LOADING" });
    const URL = `/api/v1/chat/init${isAdmin ? "?admin=true" : ""}`;
    try {
      const response = await fetch(URL, {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      const data = await response.json();
      if (data?.status?.success) {
        dispatch({ type: "LOADED", payload: data });
        isAdmin
          ? setChannel(
              data?.data?.channels.find((chatChannel) =>
                chatChannel.channel_url.startsWith("CC")
              )
            )
          : setChannel(
              data?.data?.channels.find((chatChannel) =>
                chatChannel.channel_url.startsWith("DR")
              )
            );
      } else {
        dispatch({ type: "ERROR" });
      }
      return data;
    } catch (e) {
      return null;
    }
  };

  useEffect(async () => {
    const params = new URLSearchParams(location.search);
    const admin = params.get("admin"); // will be a string or null

    setIsAdmin(admin === "true");

    const chatStatus = await checkChatStatus();
    chatStatus?.status?.success &&
      chatStatus?.init &&
      (await initChat(admin === "true"));
  }, []);

  if (state.IS_LOADING || isChatActivatedState.IS_LOADING) {
    return (
      <>
        <NavigateBack
          title={isAdmin ? t("CHAT.msgReceptionist") : t("CHAT.msgDoctor")}
        />
        <div className="body_content py-2 d-flex justify-content-center align-items-center">
          <Spinner />
        </div>
      </>
    );
  }

  if (state.IS_ERROR || isChatActivatedState.IS_ERROR) {
    return (
      <>
        <NavigateBack
          title={isAdmin ? t("CHAT.msgReceptionist") : t("CHAT.msgDoctor")}
        />
        <div className="body_content py-2">Something went wrong.</div>
      </>
    );
  }

  if (isChatActivatedState.IS_LOADED && isChatActivatedState.data == false) {
    return (
      <>
        <NavigateBack
          title={isAdmin ? t("CHAT.msgReceptionist") : t("CHAT.msgDoctor")}
        />
        <div className="body_content py-2">
          {/* <div className="inner_body "></div> */}

          <div>
            <div className={classes.messageInputParent}>
              <MessageInput
                isChatActivatedState={isChatActivatedState}
                isFileShareEnabled={false}
                initChat={initChat}
                isAdmin={isAdmin}
                dispatchIsChatActivated={dispatchIsChatActivated}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (
    isChatActivatedState.IS_LOADED &&
    isChatActivatedState.data == true &&
    state.IS_LOADED &&
    state.data
  )
    return (
      <>
        <SendbirdProvider
          appId={state?.data?.chatProviderMetadata?.appId} // Specify your Sendbird application ID.
          userId={profile.patientId}
          accessToken={state?.data?.chatData?.sessionToken} // Specify your user ID.
        >
          <NavigateBack
            title={isAdmin ? t("CHAT.msgReceptionist") : t("CHAT.msgDoctor")}
          />
          <div className="body_content py-2">
            {/* <div className="inner_body "></div> */}
            <ChannelProvider channelUrl={channel?.channel_url}>
              <div>
                <MessageListParent
                  profile={profile.patientId}
                  isAdmin={isAdmin}
                />
                <div className={classes.messageInputParent}>
                  <MessageInput
                    isChatActivatedState={isChatActivatedState}
                    isFileShareEnabled={channel?.data.fileUpload === true}
                    initChat={initChat}
                    isAdmin={isAdmin}
                    dispatchIsChatActivated={dispatchIsChatActivated}
                  />
                </div>
              </div>
            </ChannelProvider>
          </div>
        </SendbirdProvider>
      </>
    );

  return (
    <>
      <NavigateBack
        title={isAdmin ? t("CHAT.msgReceptionist") : t("CHAT.msgDoctor")}
      />
      <div className="body_content py-2 d-flex justify-content-center align-items-center">
        <Spinner />
      </div>
    </>
  );
};

export default ChatPage;
